// Vendors
import React from 'react';
// Contexts
import { useUploadIdContextConsumerHook } from '../../contexts/upload-id.context';
// Enumerations
import { UploadIdStatesEnumeration } from '../../enumerations/upload-id-states.enumeration';
// Views
import { UploadIdDifferentDataView } from '../../views/different-data/upload-id-different-data.view';
import { UploadIdLandingView } from '../../views/landing/upload-id-landing.view';
import { UploadIdVerificationView } from '../../views/verification/upload-id-verification.view';

const UploadIdOrchestratorComponent = (): React.JSX.Element => {
  const { uploadIdState } = useUploadIdContextConsumerHook();

  const UploadIdFlowComponent = {
    [UploadIdStatesEnumeration.DIFFERENT_DATA]: UploadIdDifferentDataView,
    [UploadIdStatesEnumeration.LANDING]: UploadIdLandingView,
    [UploadIdStatesEnumeration.VERIFICATION]: UploadIdVerificationView,
  }[uploadIdState];

  return <UploadIdFlowComponent />;
};

export { UploadIdOrchestratorComponent };
